import React, { PropTypes } from 'react';
import NumberFormat from 'react-number-format';

const DEFAULT_SYMBOL = '$';

export function money (props) {
  const {
    options,
    value,
    onChange,
    required,
  } = props;

  return (
    <Money
      required={required}
      value={value}
      onChange={onChange}
      {...options}
    />

  );
}

class Money extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      value,
      onChange,
      currency,
      symbol = DEFAULT_SYMBOL,
      required,
      hidden,
      disabled,
      allowNegative
    } = this.props

    let newValue;
    if(!value){
      newValue = ''
    } else {
      newValue = value
    }

    let displayHidden = hidden ? 'none' : ''

    return (
      <div className='number-input money form-input' style={{display: displayHidden }}>
        <NumberFormat
          disabled={disabled}
          value={newValue}
          allowNegative={allowNegative? allowNegative: false}
          onChange={(event)=>{
            let value = event.target.value || '';
            onChange(value.replace('$', ''));
          }}
          placeholder='$0'
          required={required}
          decimalScale={2}
          thousandSeparator={false}
          className='form-control'
          prefix={symbol} />
        <div className='unit-marker'>{currency}</div>
      </div>
    );

  }
}

export default Money;



// WEBPACK FOOTER //
// ./src/components/Form/Fields/Money/index.js